export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAEElEQVQIHQEFAPr/AAAAALMAuAC0m2NIDgAAAABJRU5ErkJggg=="